export default {
  cookies: {
    title: 'Respectăm confidențialitatea dumneavoastră',
    description:
      'Folosim cookie-uri pentru funcționarea corectă a site-ului, analiza traficului și îmbunătățirea serviciilor. Puteți accepta sau refuza cookie-urile, iar alegerea poate fi modificată ulterior.',
    accept: 'Acceptă tot',
    reject: 'Refuză',
    privacy_policy: 'Politica de confidențialitate'
  }
}
